import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Testemonial1 from "../../assets/gallery/Testemonial1.jpg";
import Testemonial2 from "../../assets/gallery/Testemonial2.jpg";
import Testemonial3 from "../../assets/gallery/Testemonial3.jpg"; 


const TESTIMONIALS = [
   {
    quote:
      "Die Reinigung war makellos und das Team sehr zuverlässig. Seitdem wir GVSI Clean & Care beauftragen, glänzen unsere Büros jeden Tag",
    name: "Amanda James",
    title: "Direktorin für Betrieb",
    image: Testemonial3,
  },
  {
    quote:
      "Wir schätzen die Professionalität und Flexibilität von GVSI Clean & Care. Egal ob Grundreinigung oder regelmäßige Pflege, alles läuft reibungslos",
    name: "Daniel Kim",
    title: "Leiter Gebäudemanagement",
    image:Testemonial1,
  },
  {
    quote:
      "Schnell, gründlich und immer freundlich. Ein Service, der hält, was er verspricht – absolut empfehlenswert!",
    name: "Leila Navarro",
    title: "COO, Nimbus Gruppe",
    image: Testemonial2,
  },
];

export default function Testimonials() {
  return (
    <section id="about" className="relative overflow-hidden bg-white py-20 sm:py-24">     

      <div className="mx-auto max-w-6xl px-6 md:px-12">
        {/* Abschnitt Kopfzeile */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-flex items-center gap-2 rounded-full border border-green-200 bg-green-50 px-3 py-1 text-xs font-medium text-green-700">
            <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 12l2 2 4-4" />
              <path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Vertraut von Teams
          </span>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl lg:text-5xl">
            Was unsere Kunden sagen
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-gray-600 sm:text-lg">
            Anerkannt von Branchenprofis in Unternehmen und Sektoren.
          </p>
        </div>

        {/* Swiper */}
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={24}
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          className="mx-auto max-w-3xl"
          aria-label="Kundenreferenzen Karussell"
        >
          {TESTIMONIALS.map((t, i) => (
            <SwiperSlide key={i}>
              <article className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm sm:p-8">
                {/* Zitat-Icon */}
                <div className="mb-4 flex justify-center">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-green-50 text-green-600">
                    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
                      <path d="M7.17 6A5.17 5.17 0 0 0 2 11.17V14a4 4 0 0 0 4 4h2v-4H6a2 2 0 0 1-2-2v-.83A3.17 3.17 0 0 1 7.17 8H10V6H7.17Zm9 0A5.17 5.17 0 0 0 11 11.17V14a4 4 0 0 0 4 4h2v-4h-2a2 2 0 0 1-2-2v-.83A3.17 3.17 0 0 1 16.17 8H19V6h-2.83Z" />
                    </svg>
                  </span>
                </div>

                {/* Zitat Text */}
                <p className="text-center text-lg leading-relaxed text-gray-800 sm:text-xl">
                  “{t.quote}”
                </p>

                {/* Sterne */}
                <div className="mt-6 flex justify-center gap-1 text-amber-500" aria-label="5 von 5 Sternen">
                  {[...Array(5)].map((_, idx) => (
                    <svg
                      key={idx}
                      viewBox="0 0 20 20"
                      className="h-5 w-5"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M9.049 2.927c.3-.921 1.602-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>

                {/* Person */}
                <div className="mt-8 flex flex-col items-center">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="h-16 w-16 rounded-full border border-gray-200 object-cover ring-2 ring-white"
                    loading="lazy"
                  />
                  <h4 className="mt-4 text-base font-semibold text-gray-900 sm:text-lg">
                    {t.name}
                  </h4>
                  <p className="text-sm text-gray-500">{t.title}</p>
                </div>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>

  
      </div>

      {/* Benutzerdefiniertes Styling der Swiper-Bullets */}
      <style>{`
        .swiper-pagination-bullets {
          position: relative;
          margin-top: 22px;
        }
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: #e5e7eb; /* grau-200 */
          opacity: 1;
          margin: 0 6px !important;
          transition: all .2s ease;
        }
        .swiper-pagination-bullet:hover {
          background: #9ca3af; /* grau-400 */
        }
        .swiper-pagination-bullet-active {
          width: 26px;
          border-radius: 9999px;
          background: #10b981; /* smaragd-500 */
        }
      `}</style>
    </section>
  );
}
